import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import logo from "../../assets/logo.png";

const NavBar = () => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "background.paper",
        borderBottom: "1px solid rgba(123, 31, 162, 0.08)",
        boxShadow: "0 1px 12px rgba(123, 31, 162, 0.06)",
      }}
    >
      <Toolbar
        sx={{
          maxWidth: 1200,
          width: "100%",
          mx: "auto",
          px: { xs: 2, sm: 3, md: 4 },
          minHeight: { xs: 64, sm: 72 },
          justifyContent: "space-between",
        }}
      >
        {/* Logo */}
        <Box
          component="a"
          href="https://survivorcentral.org/"
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            transition: "opacity 0.2s ease",
            "&:hover": { opacity: 0.8 },
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Survivor Central logo"
            sx={{
              maxWidth: { xs: 60, sm: 72, md: 80 },
              height: "auto",
            }}
          />
        </Box>

        {/* Navigation Links */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: { xs: 1.5, sm: 3 },
          }}
        >
          <Link
            href="https://survivorcentral.org/"
            underline="none"
            sx={{
              color: "text.secondary",
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              fontWeight: 500,
              letterSpacing: "0.01em",
              position: "relative",
              py: 0.5,
              px: 1,
              borderRadius: 1.5,
              transition: "all 0.2s ease",
              "&:hover": {
                color: "primary.main",
                backgroundColor: "rgba(123, 31, 162, 0.04)",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%) scaleX(0)",
                width: "60%",
                height: "2px",
                borderRadius: "1px",
                background: "linear-gradient(90deg, #7B1FA2, #E040FB)",
                transition: "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              },
              "&:hover::after": {
                transform: "translateX(-50%) scaleX(1)",
              },
            }}
          >
            Home
          </Link>
          <Link
            href="/"
            underline="none"
            sx={{
              color: "text.secondary",
              fontSize: { xs: "0.875rem", sm: "0.9375rem" },
              fontWeight: 500,
              letterSpacing: "0.01em",
              position: "relative",
              py: 0.5,
              px: 1,
              borderRadius: 1.5,
              transition: "all 0.2s ease",
              "&:hover": {
                color: "primary.main",
                backgroundColor: "rgba(123, 31, 162, 0.04)",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%) scaleX(0)",
                width: "60%",
                height: "2px",
                borderRadius: "1px",
                background: "linear-gradient(90deg, #7B1FA2, #E040FB)",
                transition: "transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
              },
              "&:hover::after": {
                transform: "translateX(-50%) scaleX(1)",
              },
            }}
          >
            Questionnaire
          </Link>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
